<template>
  <question-base-wrapper
    question-id="medical-conditions"
    :title="questionTitle"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed }"
      :vid="`${stepId}_medical-conditions`"
      name="Medical Conditions"
      rules="required"
    >
      <radio
        v-model="medicalConditionsModel"
        :data-test="fieldTrackerId.main"
        :name="`${stepId}_medical-conditions`"
        :items="constants.YES_NO"
        :error="failed"
      />
    </validation-provider>
    <form-row v-if="medicalConditionsModel">
      <validation-provider
        v-slot="{ errors }"
        :vid="`${stepId}_medical-conditions`"
        name="Medical Conditions"
        rules="listOptionRequired"
      >
        <qz-select
          v-model="questionData.medicalConditions"
          :data-test="fieldTrackerId.other"
          :items="medicalConditionsOptions"
          :placeholder="helpers.getPlaceholderResponsiveText('Please select medical condition', isMobile)"
          :error-messages="errors"
        />
      </validation-provider>
    </form-row>
  </question-base-wrapper>
</template>

<script>
import {
  omit,
  snakeCase,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-medical-conditions',
  extends: QuestionBase,
  data () {
    return {
      fields: ['medicalConditions'],
    };
  },
  computed: {
    isMobile () { return this.$vuetify.breakpoint.smAndDown; },
    defaultTitle () {
      return `Do ${this.isAdditional ? 'they' : 'you'} have any medical conditions or disabilities that the DVLA needs to be notified of?`;
    },
    questionTitle () {
      if (!this.isAdditional) {
        return this.title || this.defaultTitle;
      }
      return this.titleAdditional || this.title || this.defaultTitle;
    },
    medicalConditionsModel: {
      get () {
        const { medicalConditions } = this.questionData;
        if (medicalConditions === null) return null;
        if (medicalConditions === 'N') return false;

        return true;
      },
      set (val) {
        this.questionData.medicalConditions = val ? '' : 'N';
      },
    },
    medicalConditionsOptions () {
      const options = this.optionsConfig?.options ?? this.constants.DRIVER_MEDICAL_CONDITIONS;

      return this.helpers.createOptions({ source: omit(options, ['N']) });
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.medicalConditions),
        other: `${snakeCase(this.questionFields.medicalConditions)}_other`,
      };
    },
  },
};
</script>
